/**
 * Copyright © 2026 Adnuntius AS.
 */
import {LocalStorage} from "./local-storage";
import * as moment from 'moment';
import * as _ from "lodash";

type SessionData = {
  accessToken: string;
  refreshToken: string;
  scope: string;
  username: string;
  expires: string;
  masqueraderUsername: string;
  twoFactorAuthType: string;
};

export class Session {
  private static instance: Session;

  static readonly SESSION_KEY = 'session';

  session: SessionData | any;

  private constructor() {
  }

  public static obtain(): Session {
    if (!this.instance) {
      this.instance = new Session();
    }
    const localStorageSession = LocalStorage.obtain().getItem(Session.SESSION_KEY);
    this.instance.session = _.isObject(localStorageSession) && !_.isEmpty(localStorageSession) ? localStorageSession : {};
    return this.instance;
  }

  public static obtainData(): SessionData {
    return this.obtain().session;
  }

  isExpired(): boolean {
    const expires = moment(this.session.expires, moment.ISO_8601, true);
    return !expires.isValid() || expires.isSameOrBefore(moment());
  }

  init(scope: string, accessToken: string, refreshToken: string, username: string, expires: number | Date, masqueraderUsername?: string, twoFactorAuthType?: string): SessionData {
    this.session.accessToken = accessToken;
    this.session.scope = scope;
    this.session.refreshToken = refreshToken;
    this.session.username = username;
    this.session.masqueraderUsername = !masqueraderUsername || masqueraderUsername === username ? "" : masqueraderUsername;
    this.session.twoFactorAuthType = !twoFactorAuthType ? "" : twoFactorAuthType;
    this.session.expires = (expires instanceof Date) ? moment(expires).toISOString() : moment().add(expires, 's').toISOString();
    LocalStorage.obtain().setItem(Session.SESSION_KEY, this.session);
    return Session.obtainData();
  }

  destroy() {
    LocalStorage.obtain().remove(Session.SESSION_KEY);
    this.session = {};
  }
}
